import { baseformulaeditor } from './baseformulaeditor.js';

class sectioneiformulaeditor extends baseformulaeditor {
	widgetDidMount() {
		var _this = this;

		///TODO: переделать на ID
		var table = document.querySelector("table[data-tformuladesc]");
		if (table) {
			table.querySelectorAll("a[data-removerow]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.removerow();
				});
			});

			table.querySelectorAll("a[data-moverowup]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.moverowup();
				});
			});

			table.querySelectorAll("a[data-moverowdown]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.moverowdown();
				});
			});

			table.querySelectorAll("a[data-addrowup]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.addrowup();
				});
			});

			table.querySelectorAll("a[data-addrowdown]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.addrowdown();
				});
			});

			table.querySelectorAll("a[data-editOperBefore]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.editOperand("Before");
				});
			});

			table.querySelectorAll("a[data-editOperAfter]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.editOperand("After");
				});
			});

			table.querySelectorAll("input[data-tbOperAfter='']").forEach(function (a) {
				a.addEventListener("focusout", function () {
					_this.onLostFocusTbEdit("After");
				});
				a.addEventListener("keypress", function (e) {
					if (e.keyCode == 13) {
						_this.onLostFocusTbEdit("After");
					}
				});
			});
			table.querySelectorAll("input[data-tbOperBefore='']").forEach(function (a) {
				a.addEventListener("focusout", function () {
					_this.onLostFocusTbEdit("Before");
				});
				a.addEventListener("keypress", function (e) {
					if (e.keyCode == 13) {
						_this.onLostFocusTbEdit("Before");
					}
				});
			});

			table.querySelectorAll("td[data-tdobjectcolumn]").forEach(function (td) {
				td.addEventListener("click", function () {
					_this.setSelectedRows(td);
				});
			});

			document.querySelectorAll("a[data-ot-ctr-setClick='false']").forEach(function (a) {
				var arg = a.getAttribute('data-addcontract');
				a.addEventListener("click", function () {
					_this.addcontract(arg = '' ? null : arg);
				});
			});

			document.querySelectorAll("a[data-ot-cl-setClick='false']").forEach(function (a) {
				var arg = a.getAttribute('data-addclausecontract');
				a.addEventListener("click", function () {
					_this.addclausecontract(arg = '' ? null : arg);
				});
			});

			_this.setVisibleUpDownButton();
        }		
	}
	
	setNewRowProps() {
		var _this = this;
		var row = document.querySelector("tr[data-newrow='true']");
		row.querySelector("span[data-objectlabel]").innerHTML = "";

		row.querySelector("span[data-spanoperafter]").innerHTML = "";
		row.querySelector("span[data-spanoperbefore]").innerHTML = "";

		row.querySelector("input[name='tboperbefore']").innerHTML = "";
		row.querySelector("input[name='tboperafter']").innerHTML = "";
		var isSelected = row.getAttribute("selectinserted");
		if (isSelected != null && isSelected == "true") {
			row.style.backgroundColor = null;
		}

		row.removeAttribute('data-newrow');
		row.removeAttribute('data-description');
		var spanObject = row.querySelector("span[data-objectlabel]");
		if(spanObject != null){
			spanObject.removeAttribute('attrdescr-iscontract');
			spanObject.removeAttribute('attrdescr-iscontractclause');
			spanObject.removeAttribute('attrdescr-sectionid');
			spanObject.removeAttribute('attrdescr-sectiondataid');
		}

		row.querySelector("a[data-addrowdown]").addEventListener("click", function () {
			_this.addrowdown();
		});

		row.querySelector("input[data-tbOperBefore='']").addEventListener("keypress", function (e) {
			if (e.keyCode == 13) _this.onLostFocusTbEdit("Before");
		});
		row.querySelector("input[data-tbOperAfter='']").addEventListener("keypress", function (e) {
			if (e.keyCode == 13) _this.onLostFocusTbEdit("After");
		});

		row.querySelector("input[data-tbOperAfter='']").addEventListener("focusout", function () {
			_this.onLostFocusTbEdit("After");
		});
		row.querySelector("input[data-tbOperBefore='']").addEventListener("focusout", function () {
			_this.onLostFocusTbEdit("Before");
		});

		row.querySelector("a[data-editOperBefore]").addEventListener("click", function () {
			_this.editOperand("Before");
		});
		row.querySelector("a[data-editOperAfter]").addEventListener("click", function () {
			_this.editOperand("After");
		});

		row.querySelector("a[data-removerow]").addEventListener("click", function () {
			_this.removerow();
		});

		var td = row.querySelector("td[data-tdobjectcolumn]");
		row.querySelector("td[data-tdobjectcolumn]").addEventListener("click", function () {
			_this.setSelectedRows(td);
		});

		row.querySelector("a[data-moverowup]").addEventListener("click", function () {
			_this.moverowup();
		});
		row.querySelector("a[data-moverowdown]").addEventListener("click", function () {
			_this.moverowdown();
		});

	}

	addcontract(info) {
		document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
			var text = info.split('_');
			var spanObject = tr.querySelector("span[data-objectlabel]");
			if (spanObject != null) {
				spanObject.innerHTML = "Контракт: " + text[0];
				spanObject.removeAttribute('attrdescr-iscontract');
				spanObject.removeAttribute('attrdescr-iscontractclause');
				spanObject.removeAttribute('attrdescr-sectionid');
				spanObject.removeAttribute('attrdescr-sectiondataid');
				spanObject.setAttribute('attrdescr-iscontract', text[1]);
			}
		});
		this.onChangeFormula();
	}

	addclausecontract(info) {
		document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
			var text = info.split('_');
			var spanObject = tr.querySelector("span[data-objectlabel]");
			if (spanObject != null) {
				spanObject.innerHTML = "Пункт контракта: " + text[0];
				spanObject.removeAttribute('attrdescr-iscontract');
				spanObject.removeAttribute('attrdescr-iscontractclause');
				spanObject.removeAttribute('attrdescr-sectionid');
				spanObject.removeAttribute('attrdescr-sectiondataid');
				spanObject.setAttribute('attrdescr-iscontractclause', text[1]);
			}
		});
		this.onChangeFormula();
	}

	addsectionei(info) {
		document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
			var text = info.split('_');
			var spanObject = tr.querySelector("span[data-objectlabel]");
			if (spanObject != null) {
				spanObject.innerHTML = "Сечение ЭИ: " + text[0];
				spanObject.removeAttribute('attrdescr-iscontract');
				spanObject.removeAttribute('attrdescr-iscontractclause');
				spanObject.removeAttribute('attrdescr-sectionid');
				spanObject.removeAttribute('attrdescr-sectiondataid');
				spanObject.setAttribute('attrdescr-sectionid', text[1]);
			}
		});
		this.onChangeFormula();
	}

	adddatasectionei(info) {
		document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
			var text = info.split('_');
			var spanObject = tr.querySelector("span[data-objectlabel]");
			if (spanObject != null) {
				spanObject.innerHTML = "Данные сечения ЭИ: " + text[0];
				spanObject.removeAttribute('attrdescr-iscontract');
				spanObject.removeAttribute('attrdescr-iscontractclause');
				spanObject.removeAttribute('attrdescr-sectionid');
				spanObject.removeAttribute('attrdescr-sectiondataid');
				spanObject.setAttribute('attrdescr-sectiondataid', text[1]);
			}
		});
		this.onChangeFormula();
	}
		
	onChangeFormula() {
		var table = document.querySelector("table[data-tformuladesc='tformuladesc']");
		var dictDescNew = new Object();
		var rows = table.querySelectorAll("tr[data-rid]");
		rows.forEach(function (tr) {
			var number = tr.getAttribute("data-rid");
			if (!dictDescNew[number])
				dictDescNew[number] = {};
			dictDescNew[number].stringnumber = document.querySelector("input[name='formula_un']").value;
			dictDescNew[number].stringnumber = number;
			dictDescNew[number].operBefore = tr.querySelector("span[data-spanoperbefore]").innerHTML;
			dictDescNew[number].operAfter = tr.querySelector("span[data-spanoperafter]").innerHTML;
			if (tr.querySelector("span[attrdescr-iscontract]") != null)
				dictDescNew[number].contract_ID = tr.querySelector("span[attrdescr-iscontract]").getAttribute("attrdescr-iscontract");
			if (tr.querySelector("span[attrdescr-iscontractclause]") != null)
				dictDescNew[number].contract_ID = tr.querySelector("span[attrdescr-iscontractclause]").getAttribute("attrdescr-iscontractclause");
			if (tr.querySelector("span[attrdescr-sectionid]") != null)
				dictDescNew[number].ei_Section_ID = tr.querySelector("span[attrdescr-sectionid]").getAttribute("attrdescr-sectionid");
			if (tr.querySelector("span[attrdescr-sectiondataid]") != null)
				dictDescNew[number].ei_Section_Data_ID = tr.querySelector("span[attrdescr-sectiondataid]").getAttribute("attrdescr-sectiondataid");;
		});

		document.querySelector("input[name='formulajson']").value = JSON.stringify(dictDescNew);
	}
};

Tango.registerComponent(sectioneiformulaeditor, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));


export { sectioneiformulaeditor };
